import {Theme, useFundamentalContext} from '@hm/fundamental'
import {useEffect} from 'react'

const COCKPIT_THEME_LIGHT: Theme = 'ThemeLightBlue'

export const FundamentalThemeInitializer = () => {
  const {theme: fundamental} = useFundamentalContext()

  useEffect(() => {
    if (fundamental.currentTheme !== COCKPIT_THEME_LIGHT) {
      fundamental.updateTheme(COCKPIT_THEME_LIGHT)
    }
  }, [fundamental])

  return null
}
